import script from "./editable-mv-file-record.vue?vue&type=script&setup=true&lang=js"
export * from "./editable-mv-file-record.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__